import { defineStore } from 'pinia'

import type { ModalState } from '@/types/commons'

type GlobalModalState = { show: boolean } & ModalState

export const useGlobalModalStore = defineStore('global-modal', () => {
  const modalState = ref<GlobalModalState>(getInitModalState())

  function getInitModalState(): GlobalModalState {
    return {
      show: false,
      title: '',
      body: '',
      cancelText: '',
      confirmText: '',
    }
  }

  function showModal(args: ModalState) {
    const keys: (keyof ModalState)[] = [
      'title',
      'body',
      'mainContentClass',
      'bodyClass',
      'cancelText',
      'confirmText',
      'isFooterShown',
      'isFullHeight',
      'maskClosable',
      'isConfirmBtnDisabled',
      'isCancelBtnDisabled',
      'isConfirmBtnLoading',
      'shouldCloseOnConfirm',
      'shouldCloseOnCancel',
      'zIndex',
      'onClose',
      'onCancel',
      'onConfirm',
    ]

    keys.forEach(key => {
      modalState.value[key] = args[key] as any
    })
    requestAnimationFrame(() => {
      modalState.value.show = true
    })
  }

  function hideModal() {
    requestAnimationFrame(() => {
      modalState.value.show = false
    })
  }

  function resetModalState() {
    modalState.value = getInitModalState()
  }

  return {
    modalState,
    showModal,
    hideModal,
    resetModalState,
  }
})
